import React, { useEffect, useState } from "react";
import { Card, Spinner, Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ClientSiteAssignments = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/ci/clients?includeSites=true`
        );
        setClients(res.data.clients || []);
      } catch (err) {
        console.error("Error fetching clients:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <Container fluid className="px-4 py-4">
      <h2 className="mb-4 fw-bold text-primary">Client Site Assignments</h2>

      {clients.length === 0 ? (
        <div className="text-center py-5">
          <div className="text-muted mb-2">
            <i className="bi bi-inbox fs-1"></i>
          </div>
          <p className="text-muted">No clients found.</p>
        </div>
      ) : (
        clients.map((client) => (
          <div key={client.id} className="mb-5">
            <h4 className="fw-bold mb-3 text-primary">{client.name}</h4>

            {client.sites.length === 0 ? (
              <div className="bg-light rounded-3 p-4 text-center">
                <p className="text-muted mb-0">No sites added yet.</p>
              </div>
            ) : (
              <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                {client.sites.map((site) => (
                  <Col key={site.id}>
                    <Card
                      className="shadow-sm border-0 rounded-3 site-card h-100"
                      onClick={() => navigate(`/ci/site-assignments/${site.id}`)}
                      style={{
                        cursor: "pointer",
                        transition: "all 0.25s ease",
                        backgroundColor: "#fff",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-4px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <Card.Body className="p-4">
                        <Card.Title className="fw-bold mb-2 text-dark">
                          {site.name}
                        </Card.Title>
                        <Card.Text className="text-muted small mb-1">
                          <i className="bi bi-geo-alt me-1"></i>
                          {site.city}
                          {site.state && `, ${site.state}`}
                        </Card.Text>
                        {site.system_size && (
                          <Card.Text className="text-muted small mb-0">
                            <i className="bi bi-lightning me-1"></i>
                            {site.system_size} kW
                          </Card.Text>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        ))
      )}
    </Container>
  );
};

export default ClientSiteAssignments;